import styled, { css } from 'styled-components';

export default styled.a`
  text-decoration: underline;
  font-weight: medium;
  font-family: geomanist;
  color: #000;
`;
